import { ArrowUpRightIcon, PlayIcon } from 'lucide-react';
import { HeadingText } from '../shared/HeadingText';
import { usePages } from '../../contexts/SiteContext';
import { shopLabels } from '../../data/shopLabels';
import { fill } from '../../utils/copy';
import { sectionHeading } from '../../ui/sections';
import { Section } from '../shared/Section';
import { btnOnClay, iconCircleOnClay } from '../../ui/styles';

/**
 * Podcastblok onder het journal, op klei: intro, onderwerpen en de afleveringen (extern).
 * Op klei alleen vol `text-shell` (5,6:1); blush alleen voor het grote accent in de kop.
 */
export function JournalPodcast() {
  const pages = usePages();
  const copy = pages.journal;
  const podcastUrl = copy.podcast.url;
  return <Section tone="clay" labelledBy="podcast-title" contained={false} data-id="element-7667" data-mp="134ndl8p83qsw">
      <div className="mx-auto grid max-w-content gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-7668" data-mp="29k7l8ddb2152">
        <div className="lg:col-span-5" data-id="element-7669" data-mp="2ei9fzvk3fowd">
          {copy.podcast.eyebrow && <p className="text-[14px] text-shell" data-id="element-7670" data-mp="2ekvllpnfbuby">{fill(copy.podcast.eyebrow)}</p>}
          <h2 id="podcast-title" className={`mt-5 ${sectionHeading}`} data-id="element-7671" data-mp="6xl7bhdd8mfc">
            <HeadingText heading={copy.podcast.heading} accentClassName="text-blush" data-id="element-7672" data-mp="2034m8pxz3fs" />
          </h2>
          {copy.podcast.body && <p className="mt-7 max-w-md text-[17px] leading-relaxed text-shell" data-id="element-7673" data-mp="3u19fradvry8f">{fill(copy.podcast.body)}</p>}
          <ul className="mt-7 flex flex-wrap gap-2" aria-label="Onderwerpen" data-id="element-7674" data-mp="3p3gbimw51eas">
            {copy.podcast.topics.map(t => <li key={t} className="rounded-full border border-shell/40 px-3 py-1 text-[13px] text-shell" data-id="element-7675" data-mp="3fdwqbakyd8cr">
                {t}
              </li>)}
          </ul>
          {copy.podcast.cta && <a href={podcastUrl} target="_blank" rel="noreferrer" className={`mt-9 ${btnOnClay}`} data-id="element-7676" data-mp="36di50b7znt99">
              {fill(copy.podcast.cta)}
              <span className="sr-only" data-id="element-7677" data-mp="2weit8jrxfhi1"> {shopLabels.newTab}</span>
              <ArrowUpRightIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-7678" data-mp="2wheq04s1g04w" />
            </a>}
        </div>
        <ul className="divide-y divide-shell/25 border-y border-shell/25 lg:col-span-7" aria-label="Afleveringen" data-id="element-7679" data-mp="2rr2lr58zc8vd">
          {copy.episodes.map(e => <li key={e.number} data-id="element-7680" data-mp="2cv3ic7wtewwk">
              <a href={podcastUrl} target="_blank" rel="noreferrer" className="group grid w-full gap-3 py-7 text-left sm:grid-cols-12 sm:items-center sm:gap-6" data-id="element-7681" data-mp="2hs3lob2a5ljz">
                <span className="flex items-center gap-4 sm:col-span-5" data-id="element-7682" data-mp="3afpqfmn8uw8f">
                  <span aria-hidden="true" className={iconCircleOnClay} data-id="element-7683" data-mp="2vswjb4nvowrb">
                    <PlayIcon className="h-3 w-3 fill-current" strokeWidth={1.5} data-id="element-7684" data-mp="30r7r79um4x6w" />
                  </span>
                  <span data-id="element-7685" data-mp="3oh257uqo4rsq">
                    <span className="sr-only" data-id="element-7686" data-mp="3ofr1fux83k1m">Beluister </span>
                    <span className="block type-title" data-id="element-7687" data-mp="3t7ijfh2bchg5">{e.title}</span>
                    <span className="mt-0.5 block text-[13px] text-shell" data-id="element-7688" data-mp="3t8tm1dk0vj5o">
                      Afl. {e.number} · {e.duration}
                    </span>
                  </span>
                </span>
                <span className="text-[15px] leading-relaxed text-shell sm:col-span-7" data-id="element-7689" data-mp="1ct6sjck9c7cr">{e.summary}</span>
                <span className="sr-only" data-id="element-7690" data-mp="1rkfkvtfjo6tl">{shopLabels.newTab}</span>
              </a>
            </li>)}
        </ul>
      </div>
    </Section>;
}